import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Sparkles } from "lucide-react";
import { PILL, InfoBlock } from "./shared";

export default function AudienceTab({ biz, setBiz }) {
  const a = biz.audience_plan || {};
  const [regen, setRegen] = useState(false);
  const regenerate = async () => {
    setRegen(true);
    try {
      const { data } = await api.post("/business/regenerate/audience");
      setBiz(data);
      toast.success("Regenerated");
    } catch { toast.error("Failed"); }
    setRegen(false);
  };
  return (
    <div>
      <div className="nb-card p-5 mb-6 flex items-center justify-between">
        <div className="font-display text-2xl font-extrabold">Your audience plan</div>
        <button onClick={regenerate} disabled={regen} className={`${PILL} bg-[#F5F0FF]`} data-testid="regen-audience-btn">
          {regen ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />} Regenerate
        </button>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <InfoBlock title="Best customer">{a.best_customer}</InfoBlock>
        <InfoBlock title="Key message">{a.key_message}</InfoBlock>
        <InfoBlock title="Top customer problems"><ul className="list-disc pl-5 space-y-1">{(a.top_problems || []).map((p, i) => <li key={i}>{p}</li>)}</ul></InfoBlock>
        <InfoBlock title="Where to find them"><ul className="list-disc pl-5 space-y-1">{(a.where_to_find || []).map((p, i) => <li key={i}>{p}</li>)}</ul></InfoBlock>
        <div className="md:col-span-2"><InfoBlock title="3 audience groups">
          <div className="grid sm:grid-cols-3 gap-3">
            {(a.audience_groups || []).map((g, i) => (
              <div key={i} className="p-3 bg-[#F5F0FF] border-2 border-black rounded-xl">
                <div className="font-bold">{g.label}</div>
                <div className="text-sm text-gray-700 mt-1">{g.description}</div>
              </div>
            ))}
          </div>
        </InfoBlock></div>
        <InfoBlock title="Social post ideas"><ol className="list-decimal pl-5 space-y-1">{(a.post_ideas || []).map((p, i) => <li key={i}>{p}</li>)}</ol></InfoBlock>
        <InfoBlock title="Ad angles"><ol className="list-decimal pl-5 space-y-1">{(a.ad_angles || []).map((p, i) => <li key={i}>{p}</li>)}</ol></InfoBlock>
        <div className="md:col-span-2"><InfoBlock title="First platform to focus on">
          <div className="flex items-center gap-3">
            <div className="bg-[#FF7F50] text-white px-4 py-2 rounded-xl font-bold border-2 border-black nb-shadow-sm">{a.first_platform}</div>
            <div className="text-sm text-gray-700">{a.first_platform_reason}</div>
          </div>
        </InfoBlock></div>
      </div>
    </div>
  );
}
